import { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { useTranslation } from "react-i18next";

import VerifyEmailForm from "./sections/VerifyEmailForm";
import DarkSwitch from "@/my_components/Header/dark-switch";
import { useAppContext } from "@/context/Context";
import { getPlatformStats } from "@/services/courseService";
import { ROUTE } from "@/route/app_routes.js";

import logoWhite from "../../public/images/logo/smarttech-full-white.png";
import logo from "../../public/images/logo/smarttech-full-blue.png";
import logoLight from "../../public/images/logo/smarttech-full-white.png";
import formPanelPhoto from "../../public/app_images/about/about-hero-collage.webp";

const VerifyEmail = () => {
  const { t } = useTranslation("dashboard");
  const { isLightTheme, toggleTheme } = useAppContext();
  const [stats, setStats] = useState(null);

  const FEATURES = [
    t("authWrapper.features.free", "100% free, project-based courses"),
    t("authWrapper.features.certificate", "Quizzes and a certificate when you finish"),
    t("authWrapper.features.instructors", "Real instructors who've shipped production code"),
  ];

  useEffect(() => {
    getPlatformStats()
      .then((res) => setStats(res.data))
      .catch(() => {});
  }, []);

  return (
    <>
      <DarkSwitch isLight={isLightTheme} switchTheme={toggleTheme} />

      <div className="rbt-auth-split">
        <div className="rbt-auth-split__brand">
          <span className="rbt-auth-split__brand-bg" aria-hidden="true" />
          <span className="rbt-auth-split__brand-dots" aria-hidden="true" />
          <span className="rbt-auth-split__brand-glow" aria-hidden="true" />

          <div className="rbt-auth-split__brand-inner">
            <Link href={ROUTE.home} className="rbt-auth-split__logo">
              <Image src={logoWhite} width={210} height={80} priority alt="SmartTech Academy" />
            </Link>

            <h2 className="rbt-auth-split__headline">{t("authWrapper.verifyEmail.headline", "Almost there.")}</h2>
            <p className="rbt-auth-split__sub">
              {t(
                "authWrapper.verifyEmail.subParagraph",
                "Confirm your email address to unlock full access to every free course on SmartTech Academy."
              )}
            </p>

            <ul className="rbt-auth-split__features">
              {FEATURES.map((feature) => (
                <li key={feature}>
                  <i className="feather-check-circle"></i> {feature}
                </li>
              ))}
            </ul>

            {stats && (
              <div className="rbt-hero-stats">
                <div className="rbt-hero-stats__item">
                  <span className="rbt-hero-stats__value">{stats.total_courses}+</span>
                  <span className="rbt-hero-stats__label">{t("authWrapper.stats.freeCourses", "Free courses")}</span>
                </div>
                <div className="rbt-hero-stats__item">
                  <span className="rbt-hero-stats__value">{stats.total_students}+</span>
                  <span className="rbt-hero-stats__label">{t("authWrapper.stats.studentsLearning", "Students learning")}</span>
                </div>
                <div className="rbt-hero-stats__item">
                  <span className="rbt-hero-stats__value">{stats.total_instructors}+</span>
                  <span className="rbt-hero-stats__label">{t("authWrapper.stats.realInstructors", "Real instructors")}</span>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="rbt-auth-split__form-panel">
          <div className="rbt-auth-split__form-panel-bg" aria-hidden="true">
            <Image src={formPanelPhoto} alt="" fill sizes="100vw" priority />
          </div>
          <span className="rbt-auth-split__form-panel-scrim" aria-hidden="true" />

          <div className="rbt-auth-split__form-topbar">
            <Link href={ROUTE.home} className="rbt-auth-split__mobile-logo">
              <Image src={isLightTheme ? logo : logoLight} width={158} height={60} priority alt="SmartTech Academy" />
            </Link>
            <span className="rbt-auth-split__signup-hint">
              {t("authWrapper.verifyEmail.signupHint", "Wrong account?")} <Link href={ROUTE.register}>{t("authWrapper.verifyEmail.signUpAgain", "Sign up again")}</Link>
            </span>
          </div>

          <div className="rbt-auth-split__form-wrap">
            <VerifyEmailForm />
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyEmail;
